
export const INVALID_INDEX = -1;

export const EMPLACEMENT_TYPE = "emplacement";
export const PARK_TYPE = "parc";
export const FIXE_TYPE = "fixe";
export const TEXTE_TYPE = "texte";

export const PORTE_TYPE = "porte";

export const EMPTY_DIAMOND_CLASSNAME = "empty-inventory-diamond";

export const localEnvironment = "LOCAL";
export const developpementEnvironment = "DEV";
export const productionEnvironment = "PROD";
export const app_version = "20260903.0901";
